import { getAccessCode } from '@api/api'
import { FlowCardLoading } from '@components/FlowCard'
import { Passcode } from '@components/RouteComponents'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/passcode')({
  loader: async ({ location }) => {
    let accessCodeRes
    try {
      accessCodeRes = await getAccessCode()
    } catch {
      //non-blocking error
    }

    if (!accessCodeRes) return

    const { has_access_code } = accessCodeRes.data.data
    if (has_access_code === 'true') {
      redirect({
        to: '/walletCreationOverview',
        throw: true,
        replace: true,
        search: location.search,
      })
    }
  },
  component: Passcode,
  pendingComponent: FlowCardLoading,
})
